import React from 'react'
import { Button, Text } from '@deseretbook/react-ui'
import propTypes from 'prop-types'
import addMediaToLibrary from '../../api/media/addMediaToLibrary'

/**
 * Add to Library button that redirects to dbcom purchase page
 *
 * @param {object} props - component props
 * @param {string} props.linkClasses - Additional classes to
 *
 * @returns {function} Component
 */
const AddToLibrary = ({
  isFree,
  isVip,
  isPlus,
  linkClasses,
  mediaId,
  sku,
  updateMedia,
  ...rest
}) => {
  let buttonColor = 'bookshelf'

  if (isFree) {
    buttonColor = 'bookshelf'
  } else if (isVip) {
    buttonColor = 'vip'
  } else if (isPlus) {
    buttonColor = 'plus'
  }

  /**
   * Handles updating the media object returned from the API
   */
  const handleUpdateMedia = async () => {
    try {
      const addedMedia = await addMediaToLibrary({ id: mediaId, sku })

      if (addedMedia) {
        updateMedia(addedMedia, mediaId, sku)
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Button
      className={linkClasses}
      color={buttonColor}
      style={{
        width: '10rem',
        color: buttonColor === 'vip' ? 'white' : 'black',
        minWidth: '10rem',
        borderRadius: '26px',
        padding: '1rem 28px',
        border: 'none',
      }}
      onClick={handleUpdateMedia}
      {...rest}
    >
      <Text
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '18.75px',
          color: buttonColor === 'vip' ? 'white' : 'black',
        }}
      >
        Add to Library
      </Text>
    </Button>
  )
}

AddToLibrary.defaultProps = {
  linkClasses: '',
  isFree: false,
  isVip: false,
  isPlus: false,
  mediaId: '',
  sku: '',
  updateMedia: () => {},
}

AddToLibrary.propTypes = {
  linkClasses: propTypes.string,
  isFree: propTypes.bool,
  isVip: propTypes.bool,
  isPlus: propTypes.bool,
  mediaId: propTypes.string,
  sku: propTypes.string,
  updateMedia: propTypes.func,
}

export default AddToLibrary
